import {useTranslation} from "react-i18next";
import {useTypedSelector} from "helpers/reducers";
import {PackageItemItemType} from "types/enums/PackageItemItemType";
import {PackagesCartItem} from "types/entities/PackagesCartItem";

const useCreditItemsForDrivers = () => {
    const {t} = useTranslation();
    const selectedReservation = useTypedSelector(state => state.bookingLoginState.selectedReservation);

    const packagesCartItems = selectedReservation?.packagesCart?.packagesCartItems || [];

    const getCreditItems = () => {
        return packagesCartItems.filter(item => item.packageItem?.type === PackageItemItemType.Credit);
    };

    const getCreditItemForPersonIndex = (index: number): PackagesCartItem | undefined => {
        return getCreditItems().find(item => item.person_index == index);
    };

    return {
        getCreditItemForPersonIndex,
    };
};

export default useCreditItemsForDrivers;
